import React, { useState, useEffect } from 'react';
import axios from '../config/axios';
import './UserManagement.css';

function UserManagement() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [formData, setFormData] = useState({
    nickname: '',
    nome: '',
    senha: ''
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/users');
      if (response.data.success) {
        setUsers(response.data.data);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao carregar usuários');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      if (editingUser) {
        // Atualizar senha
        await axios.patch(`/api/users/${editingUser.id}/senha`, {
          senha: formData.senha
        });
      } else {
        // Criar novo usuário
        await axios.post('/api/users', formData);
      }

      setShowForm(false);
      setEditingUser(null);
      setFormData({ nickname: '', nome: '', senha: '' });
      fetchUsers();
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao salvar usuário');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja deletar este usuário?')) {
      return;
    }

    try {
      await axios.delete(`/api/users/${id}`);
      fetchUsers();
    } catch (err) {
      setError(err.response?.data?.error || 'Erro ao deletar usuário');
    }
  };

  const handleEditPassword = (user) => {
    setEditingUser(user);
    setFormData({ nickname: user.nickname, nome: user.nome, senha: '' });
    setShowForm(true);
  };

  if (loading) {
    return <div className="loading">⏳ Carregando usuários...</div>;
  }

  return (
    <div className="user-management">
      <div className="user-management-header">
        <h2>Gerenciar Usuários</h2>
        <button
          className="btn-add-user"
          onClick={() => {
            setShowForm(true);
            setEditingUser(null);
            setFormData({ nickname: '', nome: '', senha: '' });
          }}
        >
          ➕ Novo Usuário
        </button>
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {showForm && (
        <div className="user-form-container">
          <form onSubmit={handleSubmit} className="user-form">
            <h3>{editingUser ? 'Alterar Senha' : 'Novo Usuário'}</h3>
            
            {!editingUser && (
              <>
                <div className="form-group">
                  <label>Nickname</label>
                  <input
                    type="text"
                    value={formData.nickname}
                    onChange={(e) => setFormData({ ...formData, nickname: e.target.value })}
                    required
                    placeholder="Digite o nickname"
                  />
                </div>
                <div className="form-group">
                  <label>Nome</label>
                  <input
                    type="text"
                    value={formData.nome}
                    onChange={(e) => setFormData({ ...formData, nome: e.target.value })}
                    required
                    placeholder="Digite o nome"
                  />
                </div>
              </>
            )}

            <div className="form-group">
              <label>{editingUser ? 'Nova Senha' : 'Senha'}</label>
              <input
                type="password"
                value={formData.senha}
                onChange={(e) => setFormData({ ...formData, senha: e.target.value })}
                required
                placeholder="Digite a senha"
              />
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-save">
                {editingUser ? 'Atualizar Senha' : 'Criar Usuário'}
              </button>
              <button
                type="button"
                className="btn-cancel"
                onClick={() => {
                  setShowForm(false);
                  setEditingUser(null);
                  setFormData({ nickname: '', nome: '', senha: '' });
                }}
              >
                Cancelar
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="users-list">
        {users.map((user) => (
          <div key={user.id} className="user-card">
            <div className="user-info">
              <h3>{user.nome}</h3>
              <p className="user-nickname">@{user.nickname}</p>
              {user.is_admin && <span className="admin-badge">Admin</span>}
            </div>
            <div className="user-actions">
              {!user.is_admin && (
                <>
                  <button
                    className="btn-edit"
                    onClick={() => handleEditPassword(user)}
                  >
                    🔑 Alterar Senha
                  </button>
                  <button
                    className="btn-delete"
                    onClick={() => handleDelete(user.id)}
                  >
                    🗑️ Deletar
                  </button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UserManagement;

